<footer class="footer-area">
    <div class="container">
        <div class="footer-new">
            <hr class="exclude-styling">
            <div>
                <div class="single-footer-widget mb-30">
                    <ul class="social-link" style="display: flex; justify-content: flex-end;">
                        <li><a href="{{ facebook }}" class="d-block" target="_blank"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23"
                                    fill="none">
                                    <g clip-path="url(#clip0_1_575)">
                                        <path
                                            d="M11.5 0C5.14878 0 0 5.14878 0 11.5C0 16.893 3.71312 21.4185 8.72206 22.6614V15.0144H6.35076V11.5H8.72206V9.98568C8.72206 6.07154 10.4935 4.2573 14.3364 4.2573C15.065 4.2573 16.3222 4.40036 16.8365 4.54296V7.72846C16.5651 7.69994 16.0936 7.68568 15.508 7.68568C13.6224 7.68568 12.8938 8.40006 12.8938 10.2571V11.5H16.6502L16.0048 15.0144H12.8938V22.9158C18.5881 22.2281 23.0005 17.3797 23.0005 11.5C23 5.14878 17.8512 0 11.5 0Z"
                                            fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1_575">
                                            <rect width="23" height="23" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></a>
                        </li>
                        <li><a href="{{ twitter }}" class="d-block" target="_blank"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23"
                                    fill="none">
                                    <path
                                        d="M17.5629 1.82471H20.7958L13.7328 9.89722L22.0418 20.8821H15.5359L10.4403 14.2198L4.6097 20.8821H1.37483L8.92937 12.2476L0.958496 1.82471H7.62956L12.2356 7.91428L17.5629 1.82471ZM16.4282 18.947H18.2196L6.65617 3.65813H4.73381L16.4282 18.947Z"
                                        fill="white" />
                                </svg></a>
                        </li>
                        <li><a href="{{ instagram }}" class="d-block" target="_blank"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23"
                                    fill="none">
                                    <g clip-path="url(#clip0_1_585)">
                                        <path
                                            d="M11.5 2.0709C14.5727 2.0709 14.9365 2.08437 16.1449 2.13828C17.268 2.1877 17.8744 2.37637 18.2787 2.53359C18.8133 2.74023 19.1996 2.9918 19.5994 3.3916C20.0037 3.7959 20.2508 4.17773 20.4574 4.7123C20.6146 5.1166 20.8033 5.72754 20.8527 6.84609C20.9066 8.05898 20.9201 8.42285 20.9201 11.491C20.9201 14.5637 20.9066 14.9275 20.8527 16.1359C20.8033 17.259 20.6146 17.8654 20.4574 18.2697C20.2508 18.8043 19.9992 19.1906 19.5994 19.5904C19.1951 19.9947 18.8133 20.2418 18.2787 20.4484C17.8744 20.6057 17.2635 20.7943 16.1449 20.8438C14.932 20.8977 14.5682 20.9111 11.5 20.9111C8.42734 20.9111 8.06348 20.8977 6.85508 20.8438C5.73203 20.7943 5.12559 20.6057 4.72129 20.4484C4.18672 20.2418 3.80039 19.9902 3.40059 19.5904C2.99629 19.1861 2.74922 18.8043 2.54258 18.2697C2.38535 17.8654 2.19668 17.2545 2.14727 16.1359C2.09336 14.923 2.07988 14.5592 2.07988 11.491C2.07988 8.41836 2.09336 8.05449 2.14727 6.84609C2.19668 5.72305 2.38535 5.1166 2.54258 4.7123C2.74922 4.17773 3.00078 3.79141 3.40059 3.3916C3.80488 2.9873 4.18672 2.74023 4.72129 2.53359C5.12559 2.37637 5.73652 2.1877 6.85508 2.13828C8.06348 2.08437 8.42734 2.0709 11.5 2.0709ZM11.5 0C8.37793 0 7.98711 0.0134766 6.76074 0.0673828C5.53887 0.121289 4.69883 0.318945 3.97109 0.601953C3.21191 0.898437 2.56953 1.28926 1.93164 1.93164C1.28926 2.56953 0.898438 3.21191 0.601953 3.9666C0.318945 4.69883 0.121289 5.53437 0.0673828 6.75625C0.0134766 7.98711 0 8.37793 0 11.5C0 14.6221 0.0134766 15.0129 0.0673828 16.2393C0.121289 17.4611 0.318945 18.3012 0.601953 19.0289C0.898438 19.7881 1.28926 20.4305 1.93164 21.0684C2.56953 21.7062 3.21191 22.1016 3.9666 22.3936C4.69883 22.6766 5.53438 22.8742 6.75625 22.9281C7.98262 22.982 8.37344 22.9955 11.4955 22.9955C14.6176 22.9955 15.0084 22.982 16.2348 22.9281C17.4566 22.8742 18.2967 22.6766 19.0244 22.3936C19.7791 22.1016 20.4215 21.7062 21.0594 21.0684C21.6973 20.4305 22.0926 19.7881 22.3846 19.0334C22.6676 18.3012 22.8652 17.4656 22.9191 16.2437C22.973 15.0174 22.9865 14.6266 22.9865 11.5045C22.9865 8.38242 22.973 7.9916 22.9191 6.76523C22.8652 5.54336 22.6676 4.70332 22.3846 3.97559C22.1016 3.21191 21.7107 2.56953 21.0684 1.93164C20.4305 1.29375 19.7881 0.898438 19.0334 0.606445C18.3012 0.323437 17.4656 0.125781 16.2437 0.071875C15.0129 0.0134766 14.6221 0 11.5 0Z"
                                            fill="white" />
                                        <path
                                            d="M11.5 5.59277C8.23867 5.59277 5.59277 8.23867 5.59277 11.5C5.59277 14.7613 8.23867 17.4072 11.5 17.4072C14.7613 17.4072 17.4072 14.7613 17.4072 11.5C17.4072 8.23867 14.7613 5.59277 11.5 5.59277ZM11.5 15.3318C9.38418 15.3318 7.66816 13.6158 7.66816 11.5C7.66816 9.38418 9.38418 7.66816 11.5 7.66816C13.6158 7.66816 15.3318 9.38418 15.3318 11.5C15.3318 13.6158 13.6158 15.3318 11.5 15.3318Z"
                                            fill="white" />
                                        <path
                                            d="M19.0199 5.35908C19.0199 6.12276 18.4 6.73819 17.6408 6.73819C16.8771 6.73819 16.2617 6.11826 16.2617 5.35908C16.2617 4.59541 16.8816 3.97998 17.6408 3.97998C18.4 3.97998 19.0199 4.5999 19.0199 5.35908Z"
                                            fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1_585">
                                            <rect width="23" height="23" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></a></li>
                        <li><a href="{{ youtube }}" class="d-block" target="_blank"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23"
                                    fill="none">
                                    <path
                                        d="M22.7709 6.9001C22.7709 6.9001 22.5463 5.31436 21.8545 4.61807C20.9785 3.70166 19.9992 3.69717 19.55 3.64326C16.3336 3.40967 11.5045 3.40967 11.5045 3.40967H11.4955C11.4955 3.40967 6.66641 3.40967 3.45 3.64326C3.00078 3.69717 2.02148 3.70166 1.14551 4.61807C0.453711 5.31436 0.233594 6.9001 0.233594 6.9001C0.233594 6.9001 0 8.76436 0 10.6241V12.3671C0 14.2269 0.229102 16.0911 0.229102 16.0911C0.229102 16.0911 0.453711 17.6769 1.14102 18.3731C2.01699 19.2896 3.16699 19.2581 3.6791 19.3569C5.5209 19.5321 11.5 19.586 11.5 19.586C11.5 19.586 16.3336 19.5771 19.55 19.3479C19.9992 19.294 20.9785 19.2896 21.8545 18.3731C22.5463 17.6769 22.7709 16.0911 22.7709 16.0911C22.7709 16.0911 23 14.2313 23 12.3671V10.6241C23 8.76436 22.7709 6.9001 22.7709 6.9001ZM9.12363 14.4829V8.01865L15.3363 11.262L9.12363 14.4829Z"
                                        fill="white" />
                                </svg></a>
                        </li>
                    </ul>
                </div>
            </div>
            <hr>
        </div>

        <div class="col-lg-12 col-md-12" class="appear">


            <div *ngFor="let item of footerArea">
                <!-- <thead>
                    <h3>{{item.areaName}}</h3>
                </thead> -->

                <div class="single-footer-widget">
                    <div class="container footer-link">
                        <div *ngFor="let footeritems of item.footerItems">
                            <a [href]="footeritems?.linkUrl ? footeritems?.linkUrl : '' "
                                [target]="footeritems?.linkUrl ? '_blank' : ''">{{footeritems?.name}}</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <div class="footer-new">
            <hr class="exclude-styling">
            <img src="assets/img/DitibFrance.png" alt="logo">
            <hr>
            <img [src]="logoUrl" alt="logo">
            <hr>
        </div>

        <div class="footer-navigation">

            <div class="icon-text">
                <i class='bx bx-map'></i>
                <a href="https://www.google.com/maps/place/{{address}}" target="_blank">{{address}}</a>
            </div>


            <div class="icon-text">
                <i class='bx bx-phone-call '></i>
                <a href="tel:{{telephone}}"><label>Tel:</label> {{telephone}}</a>
            </div>

            <div class="icon-text">
                <i class="fa-sharp fa-solid fa-envelope"></i>
                <a href="mailto:{{email}}">{{email}}</a>
            </div>

            <div class="icon-text">
                <i class="fa-sharp fa-regular fa-clock"></i><a> <label>{{'WEEKDAY'|translate}} {{hour}}</label> </a>
            </div>


        </div>


    </div>
    <div class="footer-bottom-area">
        <div class="container">

            <p>© Designed and Developed by <a rel="noopener" href="https://vakifglobal.com/"
                    style="display:unset !important;" target="_blank"><img
                        src="../../../../assets/img/vakifGlobalLogo.png" style="width:11%; margin-left:3px; "
                        alt=""></a></p>
        </div>
    </div>


</footer>

<ngx-scrolltop></ngx-scrolltop>